import React, { useRef } from 'react';
import { Row } from '@tanstack/table-core';
import { flexRender } from '@tanstack/react-table';
import { useEnteredView } from '@fiverr-private/hooks';
import { Box, Types } from '@fiverr-private/theme';

interface TableRowProps<T> {
  row: Row<T>;
  borderBottomWidth?: Types.BorderWidth;
  onRowClick?: (row: Row<T>) => void;
  onRowImpression?: (row: Row<T>) => void;
}

export const TableRow = <T,>({ row, onRowClick, onRowImpression, borderBottomWidth }: TableRowProps<T>) => {
  const rowRef = useRef<HTMLElement>(null);

  useEnteredView(rowRef, {
    threshold: 1,
    onEntered: () => onRowImpression?.(row),
  });

  return (
    <Box
      ref={rowRef}
      as="tr"
      boxSizing="borderBox"
      borderStyle="solid"
      borderColor="border"
      borderBottomWidth={borderBottomWidth}
      onClick={() => onRowClick?.(row)}
    >
      {row.getVisibleCells().map((cell) => (
        <Box
          as="td"
          boxSizing="borderBox"
          textAlign={cell.column.columnDef?.meta?.align || 'start'}
          className={cell.column.columnDef.meta?.className}
          key={cell.id}
          paddingY="6"
          paddingX="4"
          color="grey_1200"
          style={{ verticalAlign: 'middle' }}
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </Box>
      ))}
    </Box>
  );
};
